import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Search from '@material-ui/icons/Search';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

const useStyles = makeStyles(theme => {
  const colors = theme.palette;

  return {
    root: {
      width: '280px',
      marginRight: '80px'
    },
    input: {
      height: '40px',
      width: '100%',
      background: colors.background.default,
      paddingRight: '0',
      paddingLeft: '.65rem',
      color: colors.grey.dark,
      border: `2px solid ${colors.grey.medium}`,
      borderRadius: '4px',
      '&:before': {
        display: 'none'
      },
      '&:after': {
        display: 'none'
      },
      '&:hover': {
        borderColor: colors.accent.main,
        color: colors.accent.main
      },
      '&:focus-within': {
        borderColor: colors.primary.main,
        color: colors.primary.main,
        backgroundColor: colors.primary.light
      }
    },
    adornment: {
      marginRight: '-2px'
    },
    icon: {
      cursor: 'pointer',
      height: '40px',
      width: '40px',
      borderRadius: '0 4px 4px 0',
      color: colors.white,
      backgroundColor: colors.primary.main,
      padding: '3px'
    },
    label: {
      zIndex: '20',
      paddingLeft: '20px',
      paddingTop: '3px'
    }
  };
});

const SearchInput = ({ onSearch, ...rest }) => {
  const [term, setTerm] = useState('');
  const classes = useStyles();

  const search = () => {
    onSearch(term);
  };

  const onKeyPress = e => {
    if (e.key === 'Enter') {
      search();
    }
  };

  const onValueChange = e => {
    setTerm(e.target.value);
  };

  return (
    <TextField
      className={classes.root}
      value={term}
      // label="Search for something..."
      onKeyPress={onKeyPress}
      onChange={onValueChange}
      InputLabelProps={{
        classes: {
          formControl: classes.label
        }
      }}
      InputProps={{
        className: classes.input,
        endAdornment: (
          <InputAdornment className={classes.adornment} position="end">
            <Search className={classes.icon} onClick={search} />
          </InputAdornment>
        )
      }}
      {...rest}
    />
  );
};

SearchInput.propTypes = {
  onSearch: PropTypes.func
};
SearchInput.defaultProps = {
  onSearch: null
};

export default SearchInput;
